import { call, put } from 'redux-saga/effects';
import { leadService } from '../services/leadService';
import { leadConstants } from '../actions/constants/leadConstants';
import { commonConstants } from '../actions/constants/commonConstants';

function* listLeads(action: any): any {
  try {
    const response = yield call(leadService.listLeads, action.payload);
    if (response && response.success) {
      yield put({ type: leadConstants.listLeadsSuccess, payload: response.resultObject ?? response });
    } else {
      yield put({ type: leadConstants.listLeadsFailure, payload: response?.errorMessage });
    }
  } catch (error) {
    yield put({ type: leadConstants.listLeadsFailure, payload: error });
  }
}

function* saveLead(action: any): any {
  try {
    const response = yield call(leadService.saveLead, action.payload);
    if (response && response.success) {
      yield put({ type: leadConstants.saveLeadSuccess, payload: response.resultObject ?? response });
      yield put({ type: commonConstants.showMessageSuccess, payload: response.message || 'Lead created' });
    } else {
      yield put({ type: leadConstants.saveLeadFailure, payload: response?.errorMessage });
      yield put({ type: commonConstants.showMessageFailure, payload: response?.errorMessage });
    }
  } catch (error) {
    yield put({ type: leadConstants.saveLeadFailure, payload: error });
    yield put({ type: commonConstants.showMessageFailure, payload: error });
  }
}

function* viewLead(action: any): any {
  try {
    const response = yield call(leadService.viewLead, action.payload);
    if (response && response.success) {
      yield put({ type: leadConstants.viewLeadSuccess, payload: response.resultObject ?? response });
    } else {
      yield put({ type: leadConstants.viewLeadFailure, payload: response?.errorMessage });
    }
  } catch (error) {
    yield put({ type: leadConstants.viewLeadFailure, payload: error });
  }
}

function* updateLead(action: any): any {
  try {
    const { id, ...data } = action.payload || {};
    const response = yield call(leadService.updateLead, id, data);
    if (response && response.success) {
      yield put({ type: leadConstants.updateLeadSuccess, payload: response.resultObject ?? response });
      yield put({ type: commonConstants.showMessageSuccess, payload: response.message || 'Lead updated' });
    } else {
      yield put({ type: leadConstants.updateLeadFailure, payload: response?.errorMessage });
      yield put({ type: commonConstants.showMessageFailure, payload: response?.errorMessage });
    }
  } catch (error) {
    yield put({ type: leadConstants.updateLeadFailure, payload: error });
    yield put({ type: commonConstants.showMessageFailure, payload: error });
  }
}

function* deleteLead(action: any): any {
  try {
    const response = yield call(leadService.deleteLead, action.payload);
    if (response && response.success) {
      yield put({ type: leadConstants.deleteLeadSuccess, payload: response.resultObject ?? response });
      yield put({ type: commonConstants.showMessageSuccess, payload: response.message || 'Lead deleted' });
    } else {
      yield put({ type: leadConstants.deleteLeadFailure, payload: response?.errorMessage });
      yield put({ type: commonConstants.showMessageFailure, payload: response?.errorMessage });
    }
  } catch (error) {
    yield put({ type: leadConstants.deleteLeadFailure, payload: error });
    yield put({ type: commonConstants.showMessageFailure, payload: error });
  }
}

function* addFollowUp(action: any): any {
  try {
    const { id, ...data } = action.payload || {};
    const response = yield call(leadService.addFollowUp, id, data);
    if (response && response.success) {
      yield put({ type: leadConstants.addFollowUpSuccess, payload: response.resultObject ?? response });
      yield put({ type: commonConstants.showMessageSuccess, payload: response.message || 'Follow-up added' });
    } else {
      yield put({ type: leadConstants.addFollowUpFailure, payload: response?.errorMessage });
      yield put({ type: commonConstants.showMessageFailure, payload: response?.errorMessage });
    }
  } catch (error) {
    yield put({ type: leadConstants.addFollowUpFailure, payload: error });
    yield put({ type: commonConstants.showMessageFailure, payload: error });
  }
}

export const leadSaga = {
  listLeads,
  saveLead,
  viewLead,
  updateLead,
  deleteLead,
  addFollowUp
};
